export default {
    positiveSentimentScore: {
        iconClassName: "icon-thumbs-up",
    },
    negativeSentimentScore: {
        iconClassName: "icon-thumbs-down",
    },
    neutralSentimentScore: {
        iconClassName: "fa fa-minus-circle",
        iconName: "fa/subtract-circle-solid",
    },
    positiveSentimentTrend: {
        iconClassName: "fa fa-angle-double-up",
    },
    negativeSentimentTrend: {
        iconClassName: "fa fa-angle-double-down",
    },
    neutralSentimentTrend: {
        iconClassName: "fa fa-minus",
    },
    improvingSentimentTrend: {
        iconClassName: "deprecated/chevron-double-up",
    },
    slightlyImprovingSentimentTrend: {
        iconClassName: "chevron-small-up",
    },
    noChangeSentimentTrend: {
        iconClassName: "subtract",
    },
    slightlyDecliningSentimentTrend: {
        iconClassName: "chevron-small-down",
    },
    decliningSentimentTrend: {
        iconClassName: "deprecated/chevron-double-down",
    },
};
